module.exports = __webpack_public_path__ + "media/warnning.930b8b4e.mp3";